'use client'

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { Container } from '@src/components/Container/Container'
import { useLocale } from '@src/i18n/LocaleProvider'

export function OutageSplash() {
  const { t } = useLocale('outage-splash')

  return (
    <div className="py-12 text-center lg:py-20">
      <Container innerSpacing="standard" includeContentPadding backgroundColor="#FFF" rounded>
        <div className="flex flex-col items-center">
          <ExclamationTriangleIcon className="mb-6 size-16 text-bodi-yellow-deep-700" />
          <h2 className="text-heading-display-2 mb-8">{t('heading')}</h2>
          <p>{t('description')}</p>
        </div>
      </Container>
    </div>
  )
}
